var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearchBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    fill: "white",
    rx: 12.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM16.0976 15.123L19.3023 18.3409C19.5735 18.6132 19.5645 19.0472 19.2827 19.309C19.1501 19.4322 18.9754 19.5 18.7913 19.5C18.5968 19.5 18.4152 19.4254 18.2803 19.2901L15.0512 16.0477C14.1343 16.6698 13.0619 16.9975 11.9365 16.9975C8.93888 16.9975 6.5 14.6429 6.5 11.7487C6.5 8.85463 8.93888 6.5 11.9365 6.5C14.9342 6.5 17.3731 8.85463 17.3731 11.7487C17.3731 12.9874 16.9216 14.1773 16.0976 15.123ZM15.9549 11.7487C15.9549 9.60954 14.1523 7.86924 11.9365 7.86924C9.7208 7.86924 7.91823 9.60954 7.91823 11.7487C7.91823 13.888 9.7208 15.6283 11.9365 15.6283C14.1523 15.6283 15.9549 13.888 15.9549 11.7487Z",
    fill: "#005993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchBlue);
export default __webpack_public_path__ + "static/media/ic_search_blue.6fb2adb28d504ebf96d46f195145b263.svg";
export { ForwardRef as ReactComponent };